import { AfterViewInit, Component, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { setupPopupDraggable } from '../../helpers/deals/popup-drag';
import { CloseBreakdownErrorModal } from '../../state/designations/actions';
import { selectBreakdownsSubmissionError } from '../../state/reducer';

@Component({
  selector: 'muni-shared-breakdown-submission-error-modal',
  templateUrl: './breakdown-submission-error-modal.component.html',
  styleUrls: [
    './breakdown-submission-error-modal.component.scss'
  ]
})
export class BreakdownSubmissionErrorModalComponent implements AfterViewInit, OnDestroy {
  public validationError$ = this.store.select(selectBreakdownsSubmissionError);
  public eventListeners: (() => void)[];

  constructor(
    private store: Store,
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2
  ) { }

  ngAfterViewInit(): void {
    this.eventListeners = setupPopupDraggable(
      this.renderer,
      this.elementRef,
      'submissions-modal-drag'
    );
  }

  ngOnDestroy(): void {
    if (this.eventListeners) {
      this.eventListeners.forEach((removeListener) => removeListener());
    }
  }

  closeModal(): void {
    this.store.dispatch(new CloseBreakdownErrorModal());
  }
}